import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class DemandMessageModel extends ApiModel {
  static get path() {
    return '/backend/demand_messages/{?id}';
  }

  @computed
  get newDemandStatusId() {
    return this.get('newDemandStatus.id');
  }

  @computed
  get messageId() {
    return this.get('message.id');
  }
}
